<template>
  <b-card
    header-tag="header"
    footer-tag="footer"
    class="carousel-card-item"
    body-class="card-body"
  >
    <b-card-body>
      <CardHeadingWithIcon
        :card="card"
      />
      <b-card-text class="l-h-30 l-s-0_08 black-1">
        {{ card.context }}
      </b-card-text>
    </b-card-body>
  </b-card>
</template>

<script>
import CardHeadingWithIcon from '@/components/Carousel/CardHeadingWithIcon';

export default {
  name: 'CarouselSideCard',
  components: { CardHeadingWithIcon },
  props: {
    card: {
      type: Object,
      default: null,
    },
  },
};
</script>

<style lang="scss" scoped>

.carousel-card-item {
  margin: 0 auto;
  width: 300px;
  min-height: 400px;
  padding: 25px;
}

.card-body {
  padding: 0 !important;
}

</style>
